import {register} from '../modules/eventMap';

const init = (el) => {
    const currencyCode = el.getAttribute('data-kinde-currency-code');
    const currencySymbol = el.getAttribute('data-kinde-currency-symbol');
    const value = el.textContent.replace(currencySymbol, '').trim();
    const formattedValue = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol',
        trailingZeroDisplay: 'stripIfInteger'
    }).format(Number(value));

    el.textContent = formattedValue;
};

const formatCurrency = () => {
    register('formatCurrency', {init});
};

export {formatCurrency};
